const AbstractSyncer = require('@/lib/Syncing/AbstractSyncer');
const DataStoreNames = require('@/lib/DataStores/DataStoreNames');
const EventNames = require('@/lib/Events/EventNames');
const logFactory = require('@/libraries/DigiTickets/Logging/logFactory');

/**
 * This downloads things that are used by the kitchen screen.
 */
class KitchenDataSyncer extends AbstractSyncer {
    // This duplication of parameters being passed to the superclass' constructor looks silly but it's
    // necessary for Angular's injector to work.
    constructor(
        $injector,
        dataStore,
        eventBus,
        localStorageDataStore,
        syncStateManager,
    ) {
        super(
            $injector,
            dataStore,
            eventBus,
            localStorageDataStore,
            syncStateManager,
        );

        /**
         * @type {ConsoleLogger}
         */
        this.log = logFactory('KitchenDataSyncer');
    }

    getManagedTableNames() {
        return [
            DataStoreNames.FIELDS,
            DataStoreNames.ITEM_OPTIONS,
            DataStoreNames.KITCHEN_ZONES,
            DataStoreNames.OPTION_SETS,
            DataStoreNames.PRODUCTS,
        ];
    }

    getSyncFunctions() {
        return [
            this.createSyncRepositoryFunction(DataStoreNames.FIELDS, 'fieldRepository'),
            this.createSyncRepositoryFunction(DataStoreNames.ITEM_OPTIONS, 'itemOptionRepository'),
            this.createSyncRepositoryFunction(DataStoreNames.KITCHEN_ZONES, 'kitchenZoneRepository'),
            this.createSyncRepositoryFunction(DataStoreNames.OPTION_SETS, 'optionSetRepository'),
            this.createSyncRepositoryFunction(DataStoreNames.PRODUCTS, 'productRepository'),
        ];
    }

    requiresBranch() {
        return true;
    }

    onSyncFinish() {
        this.eventBus.broadcast(EventNames.KITCHEN_DATA_SYNCED);
    }
}

module.exports = KitchenDataSyncer;
